import { SidebarMenuBodyContainer } from './styled';
export function SidebarMenuBody(props) {
    const { children } = props;
    return <SidebarMenuBodyContainer>{children}</SidebarMenuBodyContainer>;
}
